import { render, staticRenderFns } from "./ver_agendamento_cliente.vue?vue&type=template&id=6575c67a&scoped=true&"
import script from "./ver_agendamento_cliente.vue?vue&type=script&lang=js&"
export * from "./ver_agendamento_cliente.vue?vue&type=script&lang=js&"
import style0 from "./ver_agendamento_cliente.vue?vue&type=style&index=0&id=6575c67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6575c67a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
